const setActiveMenu = (el, currentMenu) => {
  el.props.activeMenu = currentMenu
}

const resetSecondaryMenu = (el) => {
  el.classList.remove("nav--secondary-menu-open")

  let contentContainer

  if (el.classList.contains("nav--mobile")) {
    contentContainer = el.querySelector(".nav--mobile__inner-container")
  } else {
    contentContainer = el.querySelector(".nav__secondary-menu")
  }

  // remove active element class on mobile
  if (window.matchMedia("(max-width: 1023px)").matches) {
    const activeElement = el.querySelector(".nav__main-menu-link--active")

    if (activeElement) {
      activeElement.classList.remove("nav__main-menu-link--active")
    }

    if (el.querySelector(".nav__main-menu-link--active")) {
      el.querySelector(".nav__main-menu-link--active").classList.remove(
        "nav__main-menu-link--active",
      )
    }

    el.querySelectorAll(".nav__secondary-menu__item--animate-in").forEach((item) => {
      item.classList.remove("nav__secondary-menu__item--animate-in")
      item.classList.remove("nav__secondary-menu__item--visible")
      contentContainer.height = "auto"
    })
  }
}

const toggleAccordion = (open, el) => {
  if (open) {
    el.classList.add("nav__mobile-dropdown-wrapper--open")
  } else {
    el.classList.remove("nav__mobile-dropdown-wrapper--open")
  }
}

const mobileAccordions = (el) => {
  el.querySelectorAll(".nav__mobile-dropdown-wrapper").forEach((mobileDropdownWrapper) => {
    const accordionOpener = mobileDropdownWrapper.querySelector(".nav__mobile-accordion-opener")

    if (accordionOpener) {
      accordionOpener.addEventListener("click", () => {
        // close all the others but this
        accordionOpener
          .closest(".nav--mobile__column")
          .querySelectorAll(".nav__mobile-dropdown-wrapper")
          .forEach((item) => {
            if (item !== mobileDropdownWrapper) {
              item.classList.remove("nav__mobile-dropdown-wrapper--open")
            }
          })

        if (mobileDropdownWrapper.classList.contains("nav__mobile-dropdown-wrapper--open")) {
          toggleAccordion(false, mobileDropdownWrapper)
        } else {
          toggleAccordion(true, mobileDropdownWrapper)
        }
      })
    }
  })
}

const switchContent = (button, el) => {
  const targetMenu = button.getAttribute("data-targetmenu")
  const nextContent = el.querySelector(`#${targetMenu}`)
  if (button.classList.contains("nav__main-menu-link--active")) {
    return
  }

  el.querySelectorAll(".nav__main-menu-link:not(.simple)").forEach((item, index) => {
    setActiveMenu(el, index)
  })

  el.querySelectorAll(".nav__main-menu-link").forEach((button) => {
    button.classList.remove("nav__main-menu-link--active")
    button.setAttribute("aria-expanded", false)
  })
  button.classList.add("nav__main-menu-link--active")
  button.setAttribute("aria-expanded", true)

  if (button.parentNode.querySelector(".nav__secondary-navigation-item-content")) {
    if (
      window.innerHeight - 140 >
      button.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight
    ) {
      document.querySelector(".nav--mega_menu .nav__content").style.height =
        button.parentNode.querySelector(".nav__secondary-navigation-item-content").offsetHeight +
        80 +
        "px"
    } else {
      document.querySelector(".nav--mega_menu .nav__content").style.height =
        window.innerHeight - 140 + "px"
    }
  }
  el.querySelectorAll(".nav__secondary-menu__item").forEach((item) => {
    item.classList.remove("nav__secondary-menu__item--animate-in")
  })
  if (nextContent) {
    nextContent.classList.add("nav__secondary-menu__item--visible")
  }
  setTimeout(() => {
    el.querySelectorAll(".nav__secondary-menu__item").forEach((item) => {
      if (item !== nextContent) {
        item.classList.remove(
          "nav__secondary-menu__item--animate-in",
          "nav__secondary-menu__item--visible",
        )
        item.setAttribute("aria-hidden", "true")
      } else {
        item.classList.add("nav__secondary-menu__item--visible")
        item.setAttribute("aria-hidden", "false")
        requestAnimationFrame(() => {
          item.classList.add("nav__secondary-menu__item--animate-in")
        })
      }
    })
  }, 300)
}

let stickyPriorityHeight = 0

const stickySubheader = document.querySelector(".sticky-subheader")

const navScroll = (headerEl, uxPosition) => {
  const fixed = uxPosition === "fixed"
  const showOnScroll = uxPosition === "hide"
  const scrollDiff = window.scrollY - headerEl.props.lastScroll
  const spacer = document.getElementById("header-spacer")
  const stickyPriority = document.querySelector(".sticky-priority")
  headerEl.props.navMargin += scrollDiff + stickyPriorityHeight

  if (stickyPriority && stickyPriorityHeight === 0) {
    stickyPriorityHeight = stickyPriority.offsetHeight
  }

  if (!stickyPriority) {
    stickyPriorityHeight = 0
  }

  if (showOnScroll && headerEl.props.navMargin >= headerEl.offsetHeight) {
    headerEl.classList.remove("header-visible")
    const navigationItems = headerEl.querySelectorAll("toggletip-engine")

    navigationItems.forEach((navigationItem) => navigationItem.isOpen && navigationItem.close())
  } else {
    headerEl.classList.add("header-visible")
  }

  if (!headerEl.props.submenuOpen) {
    headerEl.props.navMargin = Math.max(
      0,
      Math.min(headerEl.props.navMargin, headerEl.offsetHeight),
    )
  } else {
    headerEl.props.navMargin = 0
  }

  if (showOnScroll && !headerEl.submenuOpen) {
    headerEl.style.marginTop = -headerEl.props.navMargin + "px"
  }

  if (stickySubheader && fixed) {
    headerEl.props.transformAmount = -headerEl.props.navMargin + headerEl.offsetHeight
    stickySubheader.style.top = headerEl.offsetHeight + "px"

    const stickyTouchesHeader =
      stickySubheader.getBoundingClientRect().top === headerEl.getBoundingClientRect().bottom

    stickySubheader.classList.toggle("sticky--stuck", stickyTouchesHeader)

    if (stickyTouchesHeader) {
      headerEl.style.boxShadow = "none"
    } else {
      headerEl.style.boxShadow = ""
    }
  }

  if (stickySubheader && showOnScroll) {
    if (stickySubheader.props.isStuck) {
      headerEl.props.transformAmount = -headerEl.props.navMargin + headerEl.offsetHeight
      headerEl.classList.add("sticky-active")

      stickySubheader.style.marginTop = -headerEl.props.transformAmount + "px"
      stickySubheader.style.paddingTop = headerEl.props.transformAmount + "px"
    } else {
      headerEl.classList.remove("sticky-active")
      stickySubheader.style.marginTop = 0
      stickySubheader.style.paddingTop = 0
    }
  }

  const lastScroll = Math.max(
    0,
    Math.min(window.scrollY, document.body.offsetHeight - window.innerHeight),
  )

  headerEl.props.lastScroll = lastScroll

  // add class if at top
  if (lastScroll === 0) {
    headerEl.classList.add("reached-top")
    spacer.style.paddingTop = 0
  } else {
    headerEl.classList.remove("reached-top")
    spacer.style.paddingTop = headerEl.offsetHeight + "px"
  }
}

export {
  mobileAccordions,
  resetSecondaryMenu,
  navScroll,
  switchContent,
  setActiveMenu,
}
